export default "__VITE_ASSET__3dae84f3__"